import type { FC, ReactNode } from 'react';

import styles from './EmailSignatureImageBox.module.scss';

const EmailSignatureImageBox = ({
  ref: forwardedRef,
  children,
}: { children: ReactNode } & {
  ref?: React.Ref<HTMLDivElement>;
}) => {
  return (
    <div className={styles['images-box']} ref={forwardedRef}>
      {children}
    </div>
  );
};

const EmailSignatureImagesBoxHeader: FC<React.PropsWithChildren<{ onClick?: () => void }>> = ({
  children,
  onClick,
}) => {
  return (
    <button onClick={onClick} className={styles['images-box-header']}>
      {children}
    </button>
  );
};

const EmailSignatureImagesBoxHeaderContents: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <span className={styles['images-box-header-contents']}>{children}</span>;
};

const EmailSignatureImagesBoxBody: FC<React.PropsWithChildren<{ collapsed: boolean }>> = ({
  children,
  collapsed,
}) => {
  return (
    <div data-collapsed={collapsed.toString()} className={styles['images-box-body']}>
      {children}
    </div>
  );
};

const EmailSignatureImagesBoxHeaderDivider: FC<React.PropsWithChildren<unknown>> = () => {
  return <div className={styles['images-box-header-divider']} />;
};

export {
  EmailSignatureImageBox,
  EmailSignatureImagesBoxHeader,
  EmailSignatureImagesBoxHeaderContents,
  EmailSignatureImagesBoxBody,
  EmailSignatureImagesBoxHeaderDivider,
};

EmailSignatureImageBox.displayName = 'EmailSignatureEditorImagesBox';
